const timeLogReport = {
    auditTimeLog:'Registro de tiempo de auditoría',
    filterBy:'Filtrado por',
    view:'Vista'
  }


export default timeLogReport